import { ReactNode } from 'react';
import * as React from 'react';

export enum TooltipPlacement {
  BottomEnd = 'bottom-end',
  BottomStart = 'bottom-start',
  Bottom = 'bottom',
  LeftEnd = 'left-end',
  LeftStart = 'left-start',
  Left = 'left',
  RightEnd = 'right-end',
  RightStart = 'right-start',
  Right = 'right',
  TopEnd = 'top-end',
  TopStart = 'top-start',
  Top = 'top',
}

export enum TooltipTheme {
  Default = 'default',
  Primary = 'primary',
  Violet = 'violet',
  Blue = 'blue',
}

export interface TooltipTypeProps {
  children: ReactNode;
  className?: string;
  classNameContent?: string;
  classNameTarget?: string;
  classNameWrapper?: string;
  placement?: TooltipPlacement;
  theme?: TooltipTheme;
  content?: NonNullable<React.ReactNode>;
  arrow?: boolean;
}
